(() => {
  if (window.__npPressInitialized) return;
  window.__npPressInitialized = true;
  function setup(root = document) {
    root.querySelectorAll('[data-press-carousel]:not([data-press-ready])').forEach(carousel => {
      carousel.dataset.pressReady = 'true';
      const track = carousel.querySelector('[data-press-track]');
      const prev = carousel.querySelector('[data-press-prev]');
      const next = carousel.querySelector('[data-press-next]');
      if (!track) return;
      const scrollAmount = () => {
        const card = track.querySelector('[data-press-card]');
        if (!card) return track.clientWidth;
        return card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      };
      prev.addEventListener('click', () => track.scrollBy({left: -scrollAmount(), behavior:'smooth'}));
      next.addEventListener('click', () => track.scrollBy({left: scrollAmount(), behavior:'smooth'}));
      track.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update);
      update();
    });
  }
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-press-open]');
    if (open) {
      const dialog = document.getElementById('np-press-modal-' + open.dataset.pressOpen);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-press-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('dialog.np-press-modal')) event.target.close();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  (() => {
    if (window.__npPressArchiveBound) return;
    window.__npPressArchiveBound = true;
    document.addEventListener('click', (event) => {
      const open = event.target.closest('[data-np-modal-open]');
      if (open) {
        const dialog = document.getElementById(open.dataset.npModalOpen);
        if (dialog && !dialog.open) dialog.showModal();
        return;
      }
      const close = event.target.closest('[data-np-modal-close]');
      if (close) { close.closest('dialog')?.close(); return; }
      const dialog = event.target.closest('.np-archive__modal');
      if (dialog && event.target === dialog) dialog.close();
    });
  })();
  (() => {
    if (window.__npFeaturedPressModalBound) return;
    window.__npFeaturedPressModalBound = true;

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-np-home-open]');

      if (openButton) {
        const modal = document.getElementById(
          openButton.dataset.npHomeOpen
        );

        if (modal && !modal.open) {
          modal.showModal();
        }
        return;
      }

      const closeButton = event.target.closest('[data-np-home-close]');

      if (closeButton) {
        closeButton.closest('dialog')?.close();
        return;
      }

      const modal = event.target.closest(
        '.np-featured-press__modal'
      );

      if (modal && event.target === modal) {
        modal.close();
      }
    });
  })();
